/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './form-checkbox.scss';

const FormCheckbox = (props) => {
  const {
    entityId,
    checked,
    name,
    className,
    wrapperProps,
    labelProps,
    children,
    ...restProps
  } = props;

  const { className: wrapperClasses, ...restWrapper } = wrapperProps || {};
  const { className: labelClasses, ...restLabel } = labelProps || {};

  // Strip special chars and replace spaces with - for id.
  const transformedName = name.replace(/[^a-zA-Z0-9 ]/g, '').replace(' ', '-').toLowerCase();
  const id = entityId ? `${transformedName}_${entityId}` : transformedName;

  return (
    <div
      className={clsx('form-item', 'form-item--checkbox', wrapperClasses)}
      { ...restWrapper }
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checked}
        className={clsx(className)}
        {...restProps}
      />
      <label className={clsx('ap-form-control', labelClasses)}
        htmlFor={id}
        { ...restLabel }
      >
        {children}
      </label>
    </div>
  );
};

FormCheckbox.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  wrapperProps: PropTypes.object,
  labelProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

FormCheckbox.defaultProps = {
  checked: false,
};

export default FormCheckbox;
